export enum RefundPolicy {
  NEVER = "never",
  ALWAYS = "always",
  DAYS = "days",
}
